import React from "react";
import "./Plan_Purchase_step_one.css";
import { Form } from "react-bootstrap";
import Select from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { Controller, useForm } from "react-hook-form";
import { RegxExpression } from "../../../../../utils/common";

function Plan_Purchase_step_one({
  onSubmit,
  setShowModal,
  control,
  handleSubmit,
  register,
  errors,
}) {
  const options = [
    { value: "Below 10th", label: "Below 10th" },
    { value: "10th Pass", label: "10th Pass" },
    { value: "12th Pass", label: "12th Pass" },
    { value: "Graduate & Above", label: "Graduate & Above" },
  ];

  const optionsOccupation = [
    { value: "Self Employeed", label: "Self Employeed" },
    { value: "Salaried", label: "Salaried" },
    
  ];

  return (
    <>
      <section className="tab_form_holder">
        <Form>
          <Form.Group className="field_holder" controlId="formBasicEmail">
            <Form.Label>Full Name as per your ID Proof</Form.Label>

            <Form.Control
              type="text"
              name="name"
              placeholder="Enter Full Name as per your ID Proof"
              {...register("name", {
                required: "Name is required",
              })}
              onKeyDown={(event) => {
                if (!RegxExpression.name.test(event.key)) {
                  event.preventDefault();
                }
              }}
            />
            {errors?.name && (
              <span className="invalid-feedback d-block">
                {errors.name.message}
              </span>
            )}
          </Form.Group>

          <Form.Group className="field_holder" controlId="formBasicEmail">
            <Form.Label>Email Address</Form.Label>

            <Form.Control
              type="text"
              name="name"
              placeholder="Enter Email Address"
              {...register("email", {
                required: "Email is required",
                pattern: {
                  value: RegxExpression.email,
                  message: "Invalid email address",
                },
              })}
            />
            {errors?.email && (
              <span className="invalid-feedback d-block">
                {errors.email.message}
              </span>
            )}
          </Form.Group>

          <Form.Group className="field_holder" controlId="formBasicEmail">
            <Form.Label>Occupation</Form.Label>

            <Controller
              name="occupation"
              control={control}
            
              rules={{ required: "Occupation is required" }} 
              render={({ field }) => (
                <Select
                  {...field}
                  options={optionsOccupation}
                  placeholder="Choose Occupation"
                />
              )}
            />

            {errors?.occupation && (
              <span className="invalid-feedback d-block">
                {errors.occupation.message}
              </span>
            )}
          </Form.Group>

          <Form.Group className="field_holder" controlId="formBasicEmail">
            <Form.Label>Annual Income</Form.Label>
            <Form.Control
              type="text"
              name="annual_income"
              placeholder="Enter Annual Income*"
              {...register("annual_income", {
                required: "Annual Income is required",
              })}
              onKeyDown={(e) => {
                const allowedKeys = [
                  "Backspace",
                  "Delete",
                  "ArrowLeft",
                  "ArrowRight",
                  "Tab",
                ];

                if (!/[0-9]/.test(e.key) && !allowedKeys.includes(e.key)) {
                  e.preventDefault();
                }
              }}
            />

            {errors?.annual_income && (
              <span className="invalid-feedback d-block">
                {errors.annual_income.message}
              </span>
            )}

            <Form.Text>
              <FontAwesomeIcon className="info_icon" icon={faInfoCircle} />
              Please don't include Rental property income / income received from
              interest from bank deposits / dividends / any other investments.
            </Form.Text>
          </Form.Group>

          <Form.Group className="field_holder" controlId="formBasicEmail">
            <Form.Label>Education</Form.Label>
            <Controller
              name="qualification"
              control={control}
              rules={{ required: "Education is required" }} 
              render={({ field }) => (
                <Select
                  {...field}
                  options={options}
                  placeholder="Choose Education"
                />
              )}
            />
            {errors?.qualification && (
              <span className="invalid-feedback d-block">
                {errors.qualification.message}
              </span>
            )}
          </Form.Group>
        </Form>
      </section>
    </>
  );
}

export default Plan_Purchase_step_one;
